import React from "react";
import UserAction from "../../Actions/UserAction";
import { Button, Modal } from 'react-bootstrap';
import CustomTranslation from './CustomTranslation';

class CustomOfflineModal extends React.Component {

    //constructor
    constructor(props) {
        super(props);

        //init state
        this.state = {
            user: null,
            offlineWarning: false
        };
    }

    //on mount
    componentDidMount = () => {
        this.updateElements();
    }

    //update elements
    updateElements = async () => {
        //get current user (no cache to always get fresh data from db)
        let user = await UserAction.getCurrentUserNoCache(false);

        //skip offline check if no user is logged in
        if (!user || user.savedLastAction === undefined) {
            return;
        }

        this.setState({
            user: user,
            offlineWarning: user.savedLastAction === false
        });
    }

    //Accept changes not saved
    changeSavedLastActionState = async () => {
        await UserAction.editUser(this.state.user.id, {'savedLastAction': !this.state.user.savedLastAction})
        this.updateElements();
    }

    render = () => {
        return (
            <Modal show={this.state.offlineWarning} onHide={null} backdrop={'static'} keyboard={false}>
                <Modal.Header>
                    <Modal.Title><CustomTranslation value={'KEY.Offline Warning'} /></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        <CustomTranslation value={'KEY.Your last changes whilst using the app may have not been saved please reopen the app and wait for a confirmation popup that the data has been synchronized.'} />
                    </p>
                    <p>
                        <CustomTranslation value={'KEY.If you press accept without synchronizing the app first data may be lost/the latest data form your phone wont be available on the website.'} />
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        block
                        variant={'dark'}
                        onClick={async() => {
                            this.changeSavedLastActionState();
                        }}
                    >
                        <CustomTranslation value={'KEY.Accept'} />
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default CustomOfflineModal;